module.exports = __webpack_public_path__ + "static/london-480x480-04a2a4b730643d3b2ff4aa06346aff9c.webp";